export default class DynamicImportModule {
	constructor(name, loader) {
		this.name = name;
		this.loader = loader;
		this.loaded = false;
	}

	async init() {
		if (this.loaded) {
			return;
		}

		this.loaded = true;
		await this.loader();
	}
}
